<template>
  <div :class="['nav-wrap', isFixed ? 'fixed' : '']">
    <div class="nav-con">
      <a
        :href="item.href"
        :class="['nav', item.active ? 'active' : '']"
        v-for="(item, index) in navList"
        :key="index"
        @click="changeNav(index)"
      >
       {{ item.name }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    navList: Array,
  },
  data() {
    return {
      // 用于控制消失动画
      disappear: false,
			isFixed: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandle, true)
  },
  methods: {
    changeNav(index) {
      this.navList.forEach(e => {
				e.active = false
			})
			this.navList[index].active = true
    },
		// 滚动监听
    scrollHandle() {
      console.log('document.documentElement.scrollTop1111111', document.documentElement.scrollTop)
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
      this.isFixed = scrollTop >= 560
			if (scrollTop < 1100) {
				this.navList.forEach(e => {
					e.active = false
				})
				this.navList[0].active = true
			}
			if (scrollTop >= 1100 && scrollTop <= 1880) {
				this.navList.forEach(e => {
					e.active = false
				})
				this.navList[1].active = true
			}
			if (scrollTop > 1880) {
				this.navList.forEach(e => {
					e.active = false
				})
				this.navList[2].active = true
			}
    },
  },
  computed: {},
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 768px) {
	.nav-wrap {
		background: #FFFFFF;
		border-bottom: 1px solid #E4E4E4;
		max-width: 100%;
		top: 60px;
		transition: all 0.4s ease-in-out;
		.nav-con {
			height: 60px;
			max-width: 1400px;
			margin: 0 auto;
			display: flex;
			align-content: center;
			justify-content: space-between;
			background: #FFFFFF;
			.nav {
				display: flex;
				align-items: center;
				justify-content: center;
				flex: 1;
				height: 60px;
				font-size: 16px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #202640;
				line-height: 26px;
				background: #FFFFFF;
				// text-decoration:;
			}
			.active {
				position: relative;
				&::after {
					content: ' ';
					position: absolute;
					bottom: 0;
					left: 50%;
					margin-left: -86px;
					width: 172px;
					height: 2px;
					background-color: #E61717;
				}
			}
		}
	}
	.fixed {
		width: 100%;
		position: fixed;
		top: 0px;
		left: 0px;
		z-index: 3;
	}
}
@media screen and (max-width: 768px) {
 .nav-wrap {
	display: none;
 }
}
</style>
